import { render, staticRenderFns } from "./DirSelector.vue?vue&type=template&id=d85e5e5c&scoped=true&"
import script from "./DirSelector.vue?vue&type=script&lang=js&"
export * from "./DirSelector.vue?vue&type=script&lang=js&"
import style0 from "./DirSelector.vue?vue&type=style&index=0&id=d85e5e5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85e5e5c",
  null
  
)

export default component.exports